<template>
  <!-- 替换原料显示
 -->
  <div class="modalBox">
    <div class="left" style="position: relative">
      <span style="font-size: 18px;font-weight: bold">停用原料明细  </span>
      <span>将停用原料的替换原料导入到工厂中，需尽快将停用原料从工厂中删除！</span>
    </div>
    <a-table
      bordered
      :scroll="{ x: 100, y: 300 }"
      :columns="columns"
      :data-source="dataList"
      class="tableBox"
      rowKey="id"
    >
    </a-table>
  </div>
</template>
<script>
export default {
  props: ["dataList"],
  data() {
    return {
      selectList: [],
      selectId: [],
      columns: [
        {
          title: '停用原料代码',
          dataIndex: 'code',
          width: 100,
          ellipsis: true,
        },
        {
          title: '停用原料名称',
          dataIndex: 'name',
          width: 100,
          ellipsis: true,
        },
        {
          title: '替换原料代码',
          dataIndex: 'repCode',
          width: 100,
          ellipsis: true,
        },
        {
          title: '替换原料名称',
          dataIndex: 'repName',
          width: 100,
          ellipsis: true,
        }
      ]
    }
  },
  computed: {
  },
  created() {
    console.log("now mater replace is run")
    //this.getList()
  },
  methods: {
    loadData() {
    },
  }
}
</script>
<style lang="scss">
.productSelect .ant-select-selection__clear {
  right: 20px;
}
</style>
<style lang="scss" scoped>
.nurientHead {
  display: flex;
  .left,
  .right {
    width: 40%;
    // display: flex;
  }
  .right {
    text-align: right;
  }
  .middle {
    width: 20%;
  }
}
.tableBox {
  padding: 0;
  margin-top: 20px;
  // max-height: 500px;
  // overflow-y: auto;
}
</style>
